module.exports = __webpack_public_path__ + "./data/special_questions/do_not_restrict_compound_questions.json";